import { axios, URL } from '@/request'
import { ref } from 'vue'

export const useUploadPropress = (data: Blob, type: string) => {
  const progress = ref(0)
  const promise = axios.post(URL.uploadFile, data, {
    paths: { type },
    onUploadProgress: progressEvent => {
      progress.value = ((progressEvent.loaded / progressEvent.total) * 100) | 0
    }
  } as any)

  return {
    promise,
    progress
  }
}
